import { completeEnglishIqV2Api, type ICompleteEnglishIqV2Request } from '@repo/sdk';
import { requireEnglishIqResponseData } from '../../actions/require-english-iq-response-data';

export async function completeEnglishIqV2WebSession(request: ICompleteEnglishIqV2Request) {
  const response = await completeEnglishIqV2Api(request);
  return requireEnglishIqResponseData(response.data.data);
}
